import { call, delay, put, race, select, take, takeEvery } from 'redux-saga/effects';
import * as maintenanceActions from '#app/actions/maintenance';
import * as authActions from '#app/actions/auth';

const RECOVERY_POLL_MS = 15000;
let isRecoveryPollingActive = false;

const selectMaintenanceMode = (state) => state.maintenance.maintenanceMode;

function* checkRecoveryRequest() {
  // Используем единый auth/getUser flow, чтобы проверка восстановления шла тем же путем, что и в приложении.
  // load:false предотвращает запуск полного handleAuth на каждом polling-цикле.
  yield put(
    authActions.getUser({
      load: false,
    })
  );

  // Успех getUser в auth-саге всегда диспатчит handleGetUser.
  // Если success не пришел за таймаут, считаем проверку неуспешной и идем в следующий цикл.
  const { success } = yield race({
    success: take(authActions.handleGetUser),
    timeout: delay(5000),
  });

  if (success) {
    return true;
  }

  return false;
}

function* runRecoveryLoop() {
  while (true) {
    const recovered = yield call(checkRecoveryRequest);
    if (recovered) {
      yield put(maintenanceActions.maintenanceRecovered());
      return;
    }

    yield delay(RECOVERY_POLL_MS);

    const maintenanceMode = yield select(selectMaintenanceMode);
    if (!maintenanceMode) {
      return;
    }
  }
}

function* onMaintenanceDetected() {
  if (isRecoveryPollingActive) {
    return;
  }

  isRecoveryPollingActive = true;
  try {
    yield call(runRecoveryLoop);
  } finally {
    isRecoveryPollingActive = false;
  }
}

function* onMaintenanceCheckNow() {
  const maintenanceMode = yield select(selectMaintenanceMode);
  if (!maintenanceMode) {
    return;
  }

  const recovered = yield call(checkRecoveryRequest);
  if (recovered) {
    yield put(maintenanceActions.maintenanceRecovered());
  }
}

export default function* maintenanceWatcher() {
  yield takeEvery(maintenanceActions.maintenanceDetected, onMaintenanceDetected);
  yield takeEvery(maintenanceActions.maintenanceCheckNow, onMaintenanceCheckNow);
}
